import React from 'react';
import NewAirport from './components/NewAirport';

const App = () => {
    return (
        <div>
            <NewAirport />
        </div>
    );
};

export default App;
